import * as React from 'react';

import classnames from 'classnames';
import moment from 'moment';
import _ from 'underscore';

import {isEqualDate} from 'nutshell-core/date-time';

// @ts-expect-error - imported from .js/.jsx file
import {TickCircleIcon} from '../icon/svg/tick-circle-icon';

import styles from './options.module.css';

const today = (): Date => moment().startOf('day').toDate();
const tomorrow = (): Date => moment(today()).add(1, 'day').toDate();
const yesterday = (): Date => moment(today()).subtract(1, 'day').toDate();
const endOfWeek = (): Date => moment().endOf('week').startOf('day').toDate();
const endOfMonth = (): Date => moment().endOf('month').startOf('day').toDate();

export type CannedOption = 'yesterday' | 'today' | 'tomorrow' | 'end-of-week' | 'end-of-month';

type Option = {
    id: CannedOption;
    label: string;
    value: () => Date;
};

const OPTIONS: Option[] = [
    {
        id: 'yesterday',
        label: 'Yesterday',
        value: yesterday,
    },
    {
        id: 'today',
        label: 'Today',
        value: today,
    },
    {
        id: 'tomorrow',
        label: 'Tomorrow',
        value: tomorrow,
    },
    {
        id: 'end-of-week',
        label: 'End of week',
        value: endOfWeek,
    },
    {
        id: 'end-of-month',
        label: 'End of month',
        value: endOfMonth,
    },
];

type Props = {
    type: 'creator-modal' | 'popover-picker';
    date: Date;
    onSelect: (arg1: Date) => void;
    options: CannedOption[];
};

export class CannedOptions extends React.PureComponent<Props> {
    static defaultProps = {
        options: ['today', 'tomorrow', 'end-of-week', 'end-of-month'],
    };

    render() {
        const optionsToDisplay = OPTIONS.reduce<Array<any>>((accum, option) => {
            if (
                this.props.options.includes(option.id) &&
                // Avoid duplicate values
                !accum.find((opt) => isEqualDate(opt.value(), option.value()))
            ) {
                accum.push(option);
            }

            return accum;
        }, []);

        const selectedOption = _.find(optionsToDisplay, (option) => {
            return isEqualDate(option.value(), this.props.date);
        });

        const options = optionsToDisplay.map((option) => {
            const {id, label, value} = option;

            const isSelected = selectedOption ? selectedOption.id === id : false;

            const styleName = classnames(styles['canned-option'], {
                [styles.option]: !isSelected,
                [styles['option--selected']]: isSelected,
            });

            return (
                <div key={option.id} className={styleName}>
                    <input
                        checked={isSelected}
                        id={id}
                        name={id}
                        // @ts-expect-error
                        onChange={(e) => this.props.onSelect(e.target.value)}
                        type='radio'
                        value={value().toString()}
                        className={styles.radio}
                    />
                    <label htmlFor={id} className={styles.label}>
                        <span>{label}</span>
                        {isSelected ? (
                            <TickCircleIcon size={20} className={styles['check-icon']} />
                        ) : undefined}
                    </label>
                </div>
            );
        });

        return (
            <div className={classnames(styles.container, styles[`type-${this.props.type}`])}>
                {options}
            </div>
        );
    }
}
